import React from 'react'

export function AccordionAutoIndex({ children, activeIndex }) {
  return (
    <React.Fragment>
      {React.Children.map(children, (child, index) => {
        if (child) {
          return React.cloneElement(child, { index, active: index === activeIndex })
        }
      })}
    </React.Fragment>
  )
}

AccordionAutoIndex.Item = AccordionAutoIndexItem
/**
 *
 * @param {object} props
 * @param {React.ReactElement|React.ReactElement[]} props.children
 * @param {number=} props.index
 * @param {boolean=} props.active
 */
function AccordionAutoIndexItem({ children, index, active }) {
  return (
    <React.Fragment>
      {React.Children.map(children, (child) => React.cloneElement(child, { index, active }))}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/AccordionAutoIndex/index.js